module.exports = __webpack_public_path__ + "media/images/pages/careers-support/benchmark_1-4c1218384bcce7227d7b7505107e11a8.svg";